import { CatListItem } from '@blocks-react/components/ListItem';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { FC } from 'react';
import cx from 'classnames';
import styles from './HeaderCartListItem.module.scss';

export const HeaderCartListItemSkeleton: FC = () => {
  return (
    <CatListItem data-testid="header-cart-list-item-skeleton">
      <div className="d-flex">
        <div className={cx('me-3', styles['header__cart-list-item--image'])}>
          <CatSkeleton size="lg" />
        </div>
        <div>
          <div className="my-1">
            <CatSkeleton size="sm" width="300px" />
          </div>
          <CatSkeleton size="sm" width="200px" />
        </div>
      </div>
    </CatListItem>
  );
};
